import React from 'react';
import './Loader.css'; // Uvezi CSS za stilizaciju

const Loader = () => {
    return (
        <div className="loader">
            <img src="link_to_your_loading_image.gif" alt="Loading..." />
        </div>
    );
};

export default Loader;
